(function () {
  function forcePlay(wrapper) {
    if (!wrapper || !wrapper.querySelector) return;
    var video = wrapper.querySelector('video');
    if (!video) return;

    wrapper.dataset.autoplay = 'true';
    wrapper.dataset.noPlayBtn = 'true';
    wrapper.classList.remove('internal-video--loading');
    wrapper.classList.add('internal-video--playing', 'internal-video--muted');

    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', 'auto');

    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
    });

    var playButton = wrapper.querySelector('.internal-video__play');
    if (playButton) playButton.style.visibility = 'hidden';

    var clear = function () {
      wrapper.classList.remove('internal-video--loading');
      wrapper.classList.add('internal-video--playing');
    };
    ['loadstart','loadedmetadata','loadeddata','canplay','canplaythrough','play','playing','timeupdate'].forEach(function (eventName) {
      video.addEventListener(eventName, clear, { passive: true });
    });

    function attempt() {
      clear();
      try { if (video.readyState === 0) video.load(); } catch (e) {}
      try {
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function(){ clear(); });
      } catch (e) { clear(); }
    }

    attempt();
    requestAnimationFrame(attempt);
    setTimeout(attempt, 25);
    setTimeout(attempt, 100);
    setTimeout(attempt, 350);
    setTimeout(attempt, 1000);
  }

  function run(root) {
    root = root || document;
    if (!root.querySelectorAll) return;
    root.querySelectorAll('internal-video').forEach(forcePlay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ run(document); });
  } else {
    run(document);
  }
  window.addEventListener('load', function(){ run(document); });
  document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  document.addEventListener('shopify:block:select', function(e){ run(e.target); });
  document.addEventListener('visibilitychange', function(){ if (!document.hidden) run(document); });

  var mo = new MutationObserver(function(mutations){
    mutations.forEach(function(m){
      m.addedNodes.forEach(function(node){
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('internal-video')) forcePlay(node);
        run(node);
      });
    });
  });
  if (document.documentElement) mo.observe(document.documentElement, { childList: true, subtree: true });
})();
